import { render, staticRenderFns } from "./vipCoupon.vue?vue&type=template&id=4d8cf478&scoped=true&"
import script from "./vipCoupon.vue?vue&type=script&lang=js&"
export * from "./vipCoupon.vue?vue&type=script&lang=js&"
import style0 from "./vipCoupon.vue?vue&type=style&index=0&id=4d8cf478&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cf478",
  null
  
)

export default component.exports